
class CartNotification extends HTMLElement {
  constructor() {
    super();



    this.notification = document.getElementById('cart-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    //used for bottle deposit fee app
    this.initialCount = parseInt(document.querySelector('.cart-count-bubble span:first-child')?.innerHTML) || 0;
    this.countBubbleTimer = false;
    this.countBubbleTimeMS = 200;
    this.countBubbleInteration = 0;

    this.startTimer();



  }
  startTimer() {

    clearInterval(this.countBubbleTimer);
    let bubble = document.querySelector('.cart-count-bubble span:first-child');
    if (bubble) {

      this.countBubbleTimer = setInterval(() => {
        let count = parseInt(document.querySelector('.cart-count-bubble span:first-child')?.innerHTML) || 0;

        if (count < this.initialCount || this.countBubbleInteration > 10) {
          this.initialCount = count;
          document.querySelector('.cart-count-bubble')?.setAttribute('aria-hidden', 'false');
          document.getElementById('cart-notification-button').innerHTML = `View my cart (${document.querySelector('.cart-count-bubble span:first-child').innerHTML})`;
          clearInterval(this.countBubbleTimer);
          this.countBubbleInteration = 0;
        }
        this.countBubbleInteration++;

      }, this.countBubbleTimeMS);
    } else {

    }
  }



  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {

    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    //fixed for bottle fees
    this.initialCount = parseInt(document.querySelector('.cart-count-bubble span:first-child')?.innerHTML) || 0;
    document.getElementById('cart-notification-button').innerHTML = 'View my cart';
    document.querySelector('.cart-count-bubble')?.setAttribute('aria-hidden', 'true');

    this.startTimer();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
